import type { CurrencyDto } from './schemas';
import type { Currency } from '../model/types';

/** Does a string look like a renderable image (base64 data-URI or an image URL), not an emoji/code? */
function isImageSrc(value: unknown): value is string {
  return (
    typeof value === 'string' &&
    (value.startsWith('data:image') || /^https?:\/\/\S+\.(png|jpe?g|svg|webp|gif)/i.test(value))
  );
}

/** Find the flag image anywhere in the DTO — the API's field name for it varies across endpoints. */
function findFlagImage(dto: CurrencyDto): string | null {
  for (const value of Object.values(dto)) {
    if (isImageSrc(value)) return value;
  }
  return null;
}

/** Anti-corruption: currency DTO → domain. `_id` becomes the id sent as `currency_id`. */
export function toCurrency(dto: CurrencyDto): Currency {
  return {
    id: dto._id,
    code: dto.currency,
    name: dto.currency_name ?? dto.currency,
    symbol: dto.currency_symbol ?? dto.currency,
    iso2: dto.iso2 ?? '',
    flag: dto.emoji ?? '',
    flagImage: findFlagImage(dto),
  };
}
